module.exports = __webpack_public_path__ + "img/HX.00f7b9c3.png";